import axios from '@/libs/axios';
import { queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant'; //

//
export const creation = data => {
  return axios.post(Urls.createUrl, data);
}; //

export const useCreate = ({
  config
} = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    onSuccess: () => {//
    },
    mutationFn: creation,
    ...config
  });
};